import { getRaceRegionEnum } from 'bto-models/match/races/mapper';
import HRDetailsModel from './hr-match-details-model';
import DateFilterService from '../../../services/date-filter-service';
/**
 * Model for Category/Tournaments
 */
export default class HRMatchModel {
  /**
   * class constructor method
   * @param data
   */
  constructor(data) {
    /**
     * Race number
     * @type {number}
     */
    this.raceNumber = data.racenum;
    /**
     * Race name
     * @type {string}
     */
    this.raceName = data.n;
    /**
     * Category name?
     * @type {string}
     */
    this.categoryName = data.cn || '';
    /**
     * Category id
     * @type {number}
     */
    this.categoryId = data.cid;
    /**
   * Category css?
   * @type {string}
   */
    this.categoryCss = data.ccss;
    /**
     * Sport name?
     * @type {string}
     */
    this.sportName = data.sn || '';
    /**
     * Tournament name
     * @type {string}
     */
    this.tournamentName = data.tn;
    /**
     * Tournament id
     * @type {number}
     */
    this.tournamentId = data.tid;
    /**
     * Meeting ID
     * @type {number}
     */
    this.meetingId = data.ormid;
    /**
     * Race status
     * @type {number}
     */
    this.raceStatusId = data.rsgid;
    /**
     * Race status name
     * @type {string}
     */
    this.raceStatusName = data.rsgname;
    /**
     * Each way Places
     * @type {number}
     */
    this.eachWayPlaces = data.ewp;
    /**
     * Each way label
     * @type {string}
     */
    this.ewplabel = data.ewplabel || '';
    /**
     * Track type
     * @type {string}
     */
    this.trackType = data.tt;
    /**
     * Raw date string
     * we also recieve data.ed
     * @type {string}
     */
    this.apiDateTime = data.evd;
    /**
     * Formated time string
     * @type {string}
     */
    this.time = DateFilterService.localDate(data.evd, 'time', '', APP_SETTINGS.formatting.shortTimeFormat, true);
    /**
     * Formated date string
     * @type {string}
     */
    this.date = DateFilterService.localDate(data.evd, 'date', APP_SETTINGS.formatting.fullDateFormat, '');
    /**
     * Race type
     * @type {string}
     */
    this.RaceType = data.rt;
    /**
    * Distance
    * @type {string}
    */
    this.distance = data.dis;
    /**
    * Price currency
    * @type {string}
    */
    this.priceCurrency = data.pc;
    /**
    * Handicap
    * @type {string}
    */
    this.handicap = data.hcp;
    /**
     * Outcome id
     * @type {number}
     */
    this.outcomeId = data.oid;
    /**
     * Price amount
     * @type {number}
     */
    this.priceAmount = data.pa;
    /**
     * Outright id
     * @type {number}
     */
    this.outrightID = data.outid;
    const { runnerDetails, nonRunnerDetails } = this.mapRunnerDetails(data.hrco);
    /**
     * Race runner details
     * @type {HRDetailsModel[]}
     */
    this.matchOdds = runnerDetails;
    /**
     * Non runners details
     * @type {HRDetailsModel[]}
     */
    this.nonRunners = nonRunnerDetails;
    /**
     * Weather information
     * @type {string}
     */
    this.weather = data.w;
    /**
     * Track information
     * @type {string}
     */
    this.track = data.go;
    /**
     * Flag if live stream is available
     * @type {Boolean}
     */
    this.hasLiveStream = data.lc;
    /**
     * Race region enum value, used to get greyhound region specific images
     * @type {import('bto-models/match/races/interfaces').TRaceRegionValues}
     */
    this.raceRegion = getRaceRegionEnum(data.rreg);
  }
  /**
   * Map horse race runners details
   * @param {*} runnerDetailsList - list of runner details
   */
  mapRunnerDetails(runnerDetailsList) {
    if (!runnerDetailsList) {
      return {
        runnerDetails: [],
        nonRunnerDetails: [],
      };
    }
    let runnerDetails = [];
    let nonRunnerDetails = [];
    runnerDetailsList.forEach(o => {
      let odd = new HRDetailsModel({
        ...o,
        time: this.time,
        date: this.date,
        raceName: this.raceName,
      });
      if (odd.active) {
        odd.ewplabel = this.ewplabel;
        odd.eachWayPlace = this.eachWayPlaces;
        runnerDetails.push(odd);
      }
      if (!odd.active) {
        nonRunnerDetails.push(odd);
      }
    });
    return { runnerDetails, nonRunnerDetails };
  }
}
